import React, { useEffect, useState } from 'react';
import { ReactComponent as HelpIcon } from 'assets/icons/help.svg';
import { ReactComponent as PartyHat } from 'assets/icons/party-hat.svg';
import { Button } from '@cokitchen/cokitchen-components';
import { useNavigate, useParams } from 'react-router-dom';
import authService from 'services/auth.service';
import { ROUTE_KEYS } from 'utils/constants';

const RoleAccepted = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const routeToCreatePassword = () => {
    navigate(`/${ROUTE_KEYS.AUTH}/create-password/admin`);
  };

  const verifyToken = async () => {
    try {
      const response = await authService.acceptInvitation({ token });
      if (response?.status === 201) {
        setSuccess(true);
        localStorage.setItem('user_id', response.data.data.user_id);
      } else {
        setSuccess(false);
        setError('Verification failed');
      }
    } catch (err: any) {
      setSuccess(false);
      setError(err?.response?.data?.message || 'An error occured');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    localStorage.clear();
    if (token) verifyToken();
  }, [token]);
  return (
    <div className='w-full h-[100vh] flex flex-col'>
      <div className='w-full border-b border-b-[#EFF0F0] px-3 md:px-[50px] py-[26px]'>
        <div className='flex gap-3 items-center'>
          <HelpIcon />
          <p className='text-[#2E3031] text-sm font-medium'>
            Need help? <span className='text-[#5E6164]'>contact us</span>
          </p>
        </div>
      </div>
      <div className='flex flex-col items-center justify-center space-y-4 w-full h-[80vh] px-4'>
        {loading ? (
          <p className='text-[#6F7376] text-center sm:w-[80%] md:w-[60%] lg:w-[50%]'>
            Verifying...
          </p>
        ) : success ? (
          <>
            <PartyHat />
            <h2 className='text-xl font-semibold'>Role accepted!</h2>
            <p className='text-[#6F7376] text-center sm:w-[80%] md:w-[60%] lg:w-[50%]'>
              You have been made an administrator of FoodCourt Business account.
            </p>
            <Button
              className='sm:w-[70%] md:w-[50%] lg:w-[30%]'
              small
              color='primary'
              variant='block'
              onClick={routeToCreatePassword}>
              Create Password
            </Button>
          </>
        ) : (
          <p className='text-[#6F7376] text-center sm:w-[80%] md:w-[60%] lg:w-[50%]'>{error}</p>
        )}
      </div>
    </div>
  );
};

export default RoleAccepted;
